import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import OneRepMaxCalculator from './components/OneRepMaxCalculator';



function App() {
  return (
    <div className="App">
      <header className="App-header">

      </header>
      <OneRepMaxCalculator />
    </div>
  );
}

export default App;
